import { z } from 'zod';
import { DATE_STRING_REGEX } from '../../utils/constants';
import { EducationLevelSchema } from '../education-level/educationLevelSchema';
export const EditUserEducationSchema = z
    .object({
    educationLevel: EducationLevelSchema.optional().nullable(),
    institution: z.object({
        id: z.number().int().positive().optional(),
        name: z.string().min(1)
    }),
    orientation: z.string().optional().nullable(),
    description: z.string().optional(),
    startedOn: z.string().regex(DATE_STRING_REGEX),
    endedOn: z.string().regex(DATE_STRING_REGEX).optional().nullable(),
    isTraining: z.boolean().optional()
})
    .transform((data) => {
    if (data.isTraining)
        data.educationLevel = undefined;
    return data;
});
//# sourceMappingURL=editUserEducationSchema.js.map